import { tr } from 'mmfintech-commons'
import { useCryptoCurrencyNotes } from 'mmfintech-checkout-commons'

import { WarningMessageTitle, WarningMessageWrapper } from './WarningMessage.styled'

import InfoIcon from '../../assets/icons/info-circle.svg'

export const WarningMessage = ({ currency }) => {
  const notes = useCryptoCurrencyNotes(currency, true)

  if (notes) {
    return (
      <WarningMessageWrapper>
        <WarningMessageTitle>
          <img src={InfoIcon} alt='' />
          <span>{tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.PLEASE_NOTE', 'Please note')}</span>
        </WarningMessageTitle>

        {notes.map(line => (
          <p key={line.keyName}>{line.keyName ? tr(line.keyName, line.defaultValue) : line.defaultValue}</p>
        ))}
      </WarningMessageWrapper>
    )
  }

  return null
}
